import { mapKeys, camelCase, get } from 'lodash-es'

// Expects a user attributes and session objects. Session is empty object by default.
// userAttributes is returned by fetchUserAttributes() and session is returned by fetchAuthSession()
export function mapUserAttributes(userAttributes, session = {}) {
  const allAttributes = {
    ...userAttributes,
    groups: get(
      session,
      ['tokens', 'idToken', 'payload', 'cognito:groups'],
      []
    )
  }
  return mapKeys(mapKeysToCase(allAttributes, camelCase), (_, key) => {
    if (key === 'sub') return 'id'
    if (key === 'givenName') return 'firstname'
    if (key === 'familyName') return 'lastname'
    return key
  })
}

export function mapKeysToCase(arrayOrObject, caseFn) {
  if (Array.isArray(arrayOrObject))
    return arrayOrObject.map(object => mapKeys(object, (_, key) => caseFn(key)))
  return mapKeys(arrayOrObject, (_, key) => caseFn(key))
}
